import React, { Suspense, lazy } from 'react';
import { RouteComponentProps } from 'react-router-dom';
import { EditExport } from 'src/components/export/edit-export';
import { Sidebar, Segment } from 'semantic-ui-react';
import { route } from 'src/app/route';
import { parseNumber } from 'src/utils';
import MenuBar from './menu-bar';
import { HeaderBar } from 'src/components/header-bar';
import { appConfig } from 'src/app';
const EditExportMobile = lazy(() => import('src/components/export/edit-export-mobile'));

interface IEditExportParams {
  exportId?: string;
}

export class EditExportPage extends React.PureComponent<
  RouteComponentProps<IEditExportParams>
> {
  public componentDidMount() {
    document.title = route.getPageTitle(this.props.location.pathname);
  }

  public render() {
    const importId = parseNumber(this.props.match.params.exportId);
    const title = route.getPageTitle(this.props.location.pathname);

    return (
      <Sidebar.Pushable as={Segment} className='x-page'>
        <MenuBar />

        <Sidebar.Pusher>
          <Segment basic={true}>
            <HeaderBar title={title} />

            <Suspense fallback={<div className='x-loading' />}>
              {appConfig.isMobile ?
                <EditExportMobile exportId={importId} />
                :
                <EditExport exportId={importId} />
              }
            </Suspense>
          </Segment>
        </Sidebar.Pusher>
      </Sidebar.Pushable>
    );
  }
}
